import { useQuery } from '@tanstack/react-query';

import { getAnvaRefbes, type GetAnvaRefbesResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

const TASK_REASON_REFBES_CODE = 97014;

export default function useAnvaTaskReasons(
  options?: QueryOptions<GetAnvaRefbesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.refbes(TASK_REASON_REFBES_CODE),
    queryFn: async () => {
      const result = await getAnvaRefbes(
        { path: { code: TASK_REASON_REFBES_CODE } },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
